export default "__VITE_ASSET__Cwgd2UZY__"